import React from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterListIcon,
} from '@mui/icons-material';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onFilterClick?: () => void;
  onSearchClick?: () => void;
  showFilter?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = "Search all trips and itineraries",
  value,
  onChange,
  onSearchClick,
  onFilterClick,
  showFilter = true,
}) => {
  return (
    <Box sx={{ mb: 2,justifyContent: 'center', alignItems: 'center', display: 'flex' ,flexDirection: 'row'}}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '100px',
            backgroundColor: '#FBEEE8',
          },
        }}
        InputProps={{
          // startAdornment: (
          //   <InputAdornment position="start">
          //     <SearchIcon color="action" />
          //   </InputAdornment>
          // ),
          endAdornment: showFilter ? (
            <InputAdornment position="end">
              <IconButton onClick={onSearchClick} size="small">
              <SearchIcon color="action" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
      <Box onClick={onFilterClick} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: '10px' }}>
        <FilterListIcon sx={{ cursor: 'pointer' }} />
      </Box>
    </Box>
  );
};

export default SearchBar; 